module.exports = __webpack_public_path__ + "img/title.ac10739d.webp";